import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"

import { BACKEND_APIS } from "@constants"


export default function AppPriceComparisonAlertAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
        label="Price comparison alert"
        placeholder="Select price comparison alert"
        urlAjax={`${BACKEND_APIS.CRUD}/user/price_comparison?selectorFormat=true`}
        {...props}
    />
}